// extracted by mini-css-extract-plugin
export var contrastLow = "_3i-1";
export var externalLink = "_3i-2";
export var externalLinkIcon = "_3i-3";
export var link = "_3i-0";
export var linkLabel = "_3i-4";